import { useAppSelector } from "@/shared/lib/redux"
import { selectCommunityStatistics } from "../../model"
import { fromNanoToUnit } from "@/entities/bonus"
import { toLocaleString } from "@/shared/lib/to-locale-string"

export const EmployeesStatistics = () => {
    const statistics = useAppSelector(selectCommunityStatistics)
    return (
        <div className='box h-full'>
            <div className="box_header">
                Корпоративная лояльность
            </div>
            <div className="flex items-center pb-6 screen:pb-[18px] mb-6 screen:mb-6 border-b border-[#ccc]">
                <div className="screen:text-lg text-base">Количество клиентов:</div>
                <div className="font-semibold text-2xl screen:text-[32px] pl-2 leading-[24px] screen:leading-[32px]">{toLocaleString(statistics.totalEmployees ?? 0)}</div>
            </div>
            <div className="flex items-center pb-6 screen:pb-[18px] mb-6 screen:mb-6 border-b border-[#ccc]">
                <div className="screen:text-lg text-base">Количество транзакций:</div>
                <div className="font-semibold text-2xl screen:text-[32px] pl-2 leading-[24px] screen:leading-[32px]">{toLocaleString(statistics.countEmployeesTransactions ?? 0)}</div>
            </div>
            <div className="flex items-center pb-6 screen:pb-[18px] mb-6 screen:mb-6 border-b border-[#ccc]">
                <div className="screen:text-lg text-base">Сумма транзакций:</div>
                <div className="font-semibold text-2xl screen:text-[32px] pl-2 leading-[24px] screen:leading-[32px]">{toLocaleString(fromNanoToUnit(statistics.totalEmployeesTransactions ?? 0))} ₽</div>
            </div>
        </div>
    )
}